import {grey} from 'material-ui/colors/index'

const styles = () => ({})

export const withMe = () => ({
  noCatalogsMessage: {
    marginTop: 35,
    color: 'rgba(0,0,0,.54)',
    textAlign: 'center',
  },
  container: {
    marginTop: 25,
  },
  avatar: {
    backgroundColor: grey[400],
  },
})

export const withOthers = () => ({
  noCatalogsMessage: {
    marginTop: 35,
    color: 'rgba(0,0,0,.54)',
    textAlign: 'center',
  },
  container: {
    marginTop: 15,
  },
  buttonContainer: {
    textAlign: 'right',
  },
  button: {
    marginBottom: 10,
  },
  avatar: {
    backgroundColor: grey[400],
  },
})

export const share = () => ({})

export const revoke = () => ({})

export default styles



// WEBPACK FOOTER //
// ./src/sections/shared/styles.js